"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function setupViewTracking(Vue, router, ignoredViews) {
    if (ignoredViews === void 0) { ignoredViews = []; }
    if (ignoredViews.length) {
        ignoredViews = ignoredViews.map(function (view) { return view.toLowerCase(); });
    }
    router.afterEach(function (to) {
        var viewName = (to.name || '').toLowerCase();
        if (ignoredViews && ignoredViews.indexOf(viewName) >= 0) {
            return;
        }
        var name = to.meta.gtm || to.name;
        Vue.gtm.trackView(name, to.fullPath);
    });
    return ignoredViews;
}
exports.setupViewTracking = setupViewTracking;
//# sourceMappingURL=view-tracking.js.map